import { Content } from '@backstage/core-components';
import { PageShareTitle } from '../../lib/shareTitle';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { getStoredFunMode, translate } from '../i18n';

/**
 * Dedicated ArgoCD tab on component entities. Replaces the stock Roadie
 * history-only tab (entity-content:argocd/ArgoCdPage, disabled in
 * app-config.yaml) with a self-contained view that stacks the ArgoCD overview
 * card (sync/health) on top of the deploy-history table — see
 * ../../components/argocd/ArgoCdTabContent. The argocd overview/history cards
 * are correspondingly removed from the generic Overview tab.
 *
 * Same /argocd path the stock tab used (it is disabled, so no collision) to
 * keep deep links stable, and the same annotation filter: only components
 * carrying argocd/app-selector — the annotation the cards resolve apps with —
 * get the tab. Grouped into the Deployment dropdown via app-config.yaml.
 * Kept in sync by argocdEntityContent.test.ts.
 */
export const argocdEntityContent = EntityContentBlueprint.make({
  name: 'argocd',
  params: {
    path: '/argocd',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note. "ArgoCD" is a brand name,
    // so its `en`/`fun` values are identical either way.
    title: translate('catalog.argocdEntityContent.title', getStoredFunMode()),
    filter: {
      kind: 'component',
      'metadata.annotations.argocd/app-selector': { $exists: true },
    },
    loader: () =>
      import('../../components/argocd/ArgoCdTabContent').then(m => (
        <PageShareTitle title="ArgoCD">
          <Content>
            <m.ArgoCdTabContent />
          </Content>
        </PageShareTitle>
      )),
  },
});
